<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Mensajería Interna</h4>
            <div class="small text-muted">Chat interno 1 a 1 entre usuarios del staff</div>
          </b-col>
          <b-col cols="auto" class="d-flex align-items-center">
            <WidgetVisibilityConfig
              :widgets="widgetsMeta"
              :hidden="hiddenWidgets"
              :disabled="!visibilityLoaded"
              :locked="editingLocked"
              @toggle="onToggleWidget"
              @reset="resetWidgetsVisibility"
              @toggle-lock="setEditingLocked($event)"
            />
            <ChangelogWidget moduleKey="messages" :limit="5" />
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col md="9">
          <WidgetMasonry
            v-if="visibilityLoaded"
            v-model="widgetsOrdered"
            :disabled="!visibilityLoaded || editingLocked"
            @order-end="saveWidgetOrder"
            @resize-end="commitWidgetSize"
          >
            <template v-slot:default="{ item }">
                <Widget
                  :configWidget="configWidget"
                  :reference="item.reference"
                  :hasAccess="item.hasAccess"
                  :allowHide="!editingLocked"
                  :allowDrag="!editingLocked"
                  :allowResize="!editingLocked"
                  @hide-widget="hideWidget"
                />
            </template>
          </WidgetMasonry>
        </b-col>
        <b-col md="3">
          <b-list-group class="mb-1" v-if="configSubView.elements.inbox">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openInbox()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Bandeja de Mensajes</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Conversaciones directas con otros integrantes del staff
              </p>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import WidgetVisibilityConfig from '@/components/inc/widget/WidgetVisibilityConfig'
  import WidgetMasonry from '@/components/inc/widget/WidgetMasonry'
  import DashboardWidgetsHelper from '@/components/inc/widget/DashboardWidgetsHelper'
  import ChangelogWidget from '@/components/inc/changelog/ChangelogWidget'

  export default {
    mixins: [DashboardWidgetsHelper],
    components: {
      Widget,
      WidgetVisibilityConfig,
      WidgetMasonry,
      ChangelogWidget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.MENSAJES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.MENSAJES,
          profile_id: Profiles.PERSONAL,
          elements: {}
        },
        configSubView: {
          module_id: Modules.MENSAJES,
          profile_id: Profiles.PERSONAL,
          elements: {
            inbox: true,
          }
        },
        primaryColor: '',
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      this.initDashboardWidgets()

      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.inbox = Helper.showAccessView(this.configSubView, 'inbox')
      /* Fin configuracion */
    },
    mounted() {
      this.setup()
    },
    methods: {
      setup () {
        if(Session.getSession().settings) {
          this.primaryColor = Session.getSession().settings.color_primary

          this.createCSS()
        }
      },
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      },

      openInbox() {
        this.$router.push({ name: 'MessagesStaffInbox' })
      },
    }

  }
</script>

<style>

</style>
